import { FULL_NOTIFICATION } from "../../types";


const initialState = {
  isLoading: false,
  list: [],
  total: 0,
  page: 1,
  rowsPerPage: 10,
  pages: 10,
  details: {},
  existNotification: 0, // 系統通知未讀通知數目
  existAllNotification: 0, // 系統通知與個人通知未讀數目
  isOpenNotificationList: false, //
  isOpenNotificationDetails: false, //
};

const notificationReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_NOTIFICATION.ListDrawer: {
      return {
        ...state,
        isOpenNotificationList: action.payload
      };
    }
    case FULL_NOTIFICATION.DetailsDrawer: {
      return {
        ...state,
        isOpenNotificationDetails: action.payload
      };
    }
    case FULL_NOTIFICATION.List: {
      return {
        ...state,
        ...action.payload
        // list
        // total
      };
    }
    case FULL_NOTIFICATION.Details: {
      return {
        ...state,
        details: action.payload
      };
    }
    case FULL_NOTIFICATION.UnreadTotal: {
      return {
        ...state,
        existNotification: action.payload
      };
    }
    case FULL_NOTIFICATION.UnreadAllTotal: {
      return {
        ...state,
        existAllNotification: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default notificationReducer;
